import { IconCircleXFilled } from '@tabler/icons-react';

export function ErrorMessage({ message = '' }: { message: string }) {
  return (
    <p className="mt-1 flex items-center gap-1 text-sm text-red-500">
      <IconCircleXFilled className="h-5 w-5" />
      <span className="field-error !ml-0 pt-0.5">{message}</span>
    </p>
  );
}
